import { ContextService } from '../../services/context_service';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import style from './DatenauswertungEnergiekennzahlenBrowser.less';
import { Tab, TabList, Tabs, TabPanel } from 'react-tabs';
import '../../css/tabs.css';
import { IDs } from '../../helpers/IDs';
import { LineDiagram } from './helper/lineChart';
import { WSimpleTupelList } from '../../core/lists/WSimpleTupelList';
import { formatNumber } from '../../core/formatter/formatNumber';
import { KennzahlenAuswahl } from './elements/KennzahlenAuswahl';

interface DatenauswertungEnergiekennzahlenBrowserProps extends React.ClassAttributes<any> {
    data: any;
    standortTid: number;
}

interface DatenauswertungEnergiekennzahlenBrowserState {
    kennzahlSelected: string;
}

export class DatenauswertungEnergiekennzahlenBrowser extends
    React.Component<DatenauswertungEnergiekennzahlenBrowserProps, DatenauswertungEnergiekennzahlenBrowserState> {

    constructor(props: any) {
        super(props);
        this.state = {
            kennzahlSelected: 'umsatz'
        };
    }

    private kennzahlen_statisch = ['umsatz_mitarbeiter', 'waerme_mitarbeiter', 'strom_mitarbeiter', 'stromverbrauch_absolut',
        'energiekosten_anteil', 'energiekosten_absolut'];

    render(): JSX.Element {
        return (
            <div
                style={{ display: 'flex', flexDirection: 'row', flex: 1 }}
            >
                <KennzahlenAuswahl
                    data={this.props.data}
                    kennzahlSelected={this.state.kennzahlSelected}
                    onKennzahlChange={(kennzahlSelected: string) => this.setState({ kennzahlSelected })}
                    showAll={true}
                />
                <div
                    style={{ display: 'flex', flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}
                >
                    {this.state.kennzahlSelected && this.renderKennziffer(this.state.kennzahlSelected)}
                </div>
            </div>
        );
    }
    renderKennziffer(kennziffer: string) {
        const kz = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION].find((kd: any) => kd.kuerzel === kennziffer);
        console.log('KZ: ', kz);
        return <div className={style.kachel}>
            <div className={style.kachel_titel}>{kz.kuerzel + ' - ' + kz.name + ' [' + kz.einheit + ']'}</div>
            <div
                style={{ display: 'flex', flex: 1, flexDirection: 'row' }}
            >
                {this.renderDiagramm(kennziffer, kz)}
                {this.renderTable(kennziffer, kz)}
            </div>
        </div>;
    }
    renderTable(kennziffer: string, kz: any) {
        const werte = this.props.standortTid ?
            this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            :
            this.props.data[IDs.KENNZIFFERN_BERECHNET];
        if (!werte) {
            return 'Werte nicht verfügbar';
        }
        const jahre = Object.keys(werte);
        const tupel = jahre.map((jahr: any) => {
            return {
                name: jahr,
                jahr: +jahr, // Für das Diagramm
                value: formatNumber(werte[jahr][kennziffer], 2)
            };
        });
        const title = {
            name: <b>Jahr</b>,
            value: <b>Wert</b>
        };
        return (
            <div className={style.diagramm}>
                <WSimpleTupelList
                    data={[title, ...tupel]}
                    widthName={150}
                    widthValue={150}
                />
            </div>
        );
    }
    renderDiagramm(kennziffer: string, kz: any) {
        const werte = this.props.standortTid ?
            this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            :
            this.props.data[IDs.KENNZIFFERN_BERECHNET];
        if (!werte) {
            return 'Werte nicht verfügbar';
        }
        const jahre = Object.keys(werte);
        const tupel = jahre.map((jahr: any) => {
            return {
                name: jahr,
                jahr: +jahr, // Für das Diagramm
                value: werte[jahr][kennziffer]
            };
        });
        console.log('Tupel', kz, tupel);
        return <div className={style.diagramm}>
            <LineDiagram
                key={'diag_' + kz.kuerzel}
                data={tupel}
                visibleData={['value']}
                legendTitle={[<span>{kz.name}</span>]}
                unit={[kz.einheit]}
                createNewTick={true}
                containerSize={{ width: 400, height: 250 }}
                hideLegend={true}
            />
        </div>;
    }

}
